import React from 'react';
import '../styles/DemoDashboard.css';

const DemoDashboard = () => {
  const demoPages = [
    { name: "Home Page", file: "Home_page.html", desc: "Main landing page", icon: "🏠" },
    { name: "User Dashboard", file: "User_dashboard.html", desc: "User management dashboard", icon: "👤" },
    { name: "Create Event", file: "create_event_page.html", desc: "Create new events", icon: "📅" },
    { name: "Event Page", file: "Event_page.html", desc: "Detailed event view", icon: "🎯" },
    { name: "Free Registration", file: "Free_event_registration_form.html", desc: "Free event registration", icon: "🎟️" },
    { name: "Paid Registration", file: "Paid_event_registration_form.html", desc: "Paid event registration", icon: "💳" },
    { name: "Login/Signup", file: "signin_signup_page.html", desc: "User authentication", icon: "🔐" },
    { name: "Speaker Form", file: "Speaker_form.html", desc: "Speaker application", icon: "🎤" },
  ];

  const openPage = (filename) => {
    window.open(`/demo/${filename}`, '_blank');
  };

  return (
    <div className="demo-dashboard">
      <header className="demo-header">
        <h1>EventFork Demo Pages</h1>
        <p>Click any page to open it in a new tab</p>
      </header>

      <div className="demo-grid">
        {demoPages.map((page, index) => (
          <div key={index} className="demo-card" onClick={() => openPage(page.file)}>
            <div className="demo-icon">{page.icon}</div>
            <h3>{page.name}</h3>
            <p>{page.desc}</p>
            <div className="demo-footer">
              <span className="demo-filename">{page.file}</span>
              <button className="demo-btn">Open Demo</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoDashboard;
